import {
  Box,
  Button,
  Container,
  Divider,
  Modal,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { getZones } from '../../redux/zoneRedux';
import { useState } from 'react';
import BarcodeGen from '../Barcode/BarcodeGen';

const style = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', md: '70%' },
  height: { xs: '90%', md: '70%' },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Main = () => {
  const zones = useSelector((state) => getZones(state));
  const [activeZone, setActiveZone] = useState(null);
  const [binList, setBinList] = useState(null);
  const [bin, setBin] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  console.log(bin);
  const handleModalClose = () => {
    setModalOpen(false);
  };
  return (
    <Container fixed>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          columnCount: '2',
          m: 5,
          justifyContent: 'center',
        }}
      >
        {zones.map((zone) => (
          <Box
            key={zone.id}
            sx={{
              width: '100%',
              p: 1,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              onClick={() => (
                setActiveZone(zone.areas), setBinList(null), setBin(null)
              )}
            >
              {zone.name}
            </Button>
          </Box>
        ))}
      </Box>
      <Divider />
      {activeZone && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          {activeZone.map((area) => (
            <Button
              variant="contained"
              color="secondary"
              sx={{ m: 2 }}
              onClick={() => setBinList(area.bins)}
            >
              {area.name}
            </Button>
          ))}
        </Box>
      )}
      <Divider />
      {binList && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
          }}
        >
          {binList.map((bin) => (
            <Button
              variant="contained"
              sx={{ m: 2, width: '120px' }}
              onClick={() => (setBin(bin), setModalOpen(true))}
            >
              {bin.name}
            </Button>
          ))}
        </Box>
      )}
      <Modal
        open={modalOpen}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <BarcodeGen
            value={bin?.verifyCode}
            options={{
              format: 'CODE128',
              lineColor: '#000',
              width: 10,
              height: 200,
              displayValue: false,
            }}
          />
          <Typography sx={{ fontSize: '24px' }}>{bin?.name}</Typography>
        </Box>
      </Modal>
    </Container>
  );
};

export default Main;
